import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

Vue.config.productionTip = false

//Vue.prototype.$backendURL = "http://localhost:8000/api/"
Vue.prototype.$backendURL = "https://revotec.quantumfrog.de/public/api/"



Vue.use(VueAxios, axios)
Vue.use(Buefy)

new Vue({
    router,
    store,
    render: function(h) { return h(App) }
}).$mount('#app')